import { ShopByVehicleModal } from 'components/VehicleConfigurator'

export default ShopByVehicleModal
